const value = item => String(item === null || item === undefined ? '' : item);

const commissionFields = [
  'commission',
  'commission_type',
  'jv_broker_commission',
  'jv_broker_commission_type',
];

const groupsMatch = (left, right, fields = commissionFields) => Boolean(left && right)
  && fields.every(field => value(left[field]) === value(right[field]));

export function commissionRulesMatch(left, right) {
  if (!left || !right) return false;
  if (!groupsMatch(left.sales_commission, right.sales_commission)) return false;
  if (!groupsMatch(left.trial_commission, right.trial_commission)) return false;
  const leftRebills = left.rebill_commissions || [];
  const rightRebills = right.rebill_commissions || [];
  return leftRebills.length === rightRebills.length && leftRebills.every((row, index) =>
    groupsMatch(row, rightRebills[index], [...commissionFields, 'no_of_payments']));
}

export function copyDefaultCommission(current, source) {
  return {
    ...(current || {
      id: Math.ceil(Math.random() * 100000),
      type: 1,
      name: 'Default',
      assigned_to: null,
    }),
    sales_commission: JSON.parse(JSON.stringify(source.sales_commission)),
    trial_commission: JSON.parse(JSON.stringify(source.trial_commission || source.sales_commission)),
    rebill_commissions: JSON.parse(JSON.stringify(source.rebill_commissions || [])),
  };
}
